import React, {useEffect, useState} from "react";
import socket from "../utils/clientSocket";
import "../App.css";
import CustomRange from "./CustomRange";
import {TimeVariants} from "../utils/gameEnums";

const CreateGameModal = ({showCreateModal, closeModal, clubId, friendName}) => {
    const [timeMinutes, setTimeMinutes] = useState(5);
    const [incrementSeconds, setIncrementSeconds] = useState(3);
    const [selectedVariant, setSelectedVariant] = useState("standard");
    const [selectedColor, setSelectedColor] = useState("random");
    const [evalRange, setEvalRange] = useState([]);
    const [moveRange, setMoveRange] = useState([]);
    const [optionSelected, setOptionSelected] = useState(null)
    const [evalOptionSelected, setEvalOptionSelected] = useState(null)
    const [moveOptionSelected, setMoveOptionSelected] = useState(null)
    const [isCustomTime, setIsCustomTime] = useState(false)
    const [isCreatorsHandicap, setIsCreatorsHandicap] = useState(false)
    const [isCustomJumpstart, setIsCustomJumpstart] = useState(false)
    const [missingInputs, setMissingInputs] = useState([])

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                closeModal()
            }
        }

        window.addEventListener("keydown", handleEscape)

        return () => window.removeEventListener("keydown", handleEscape)
    }, [showCreateModal]);

    //This sets a state with any missing input fields, and returns false (failed validation) if any were missing
    const validateSubmission = () => {
        const emptyInputs = []
        if (selectedVariant === "jumpstart") {
            evalRange.length === 0 && emptyInputs.push("Handicap")
            moveRange.length === 0 && emptyInputs.push("Game Stage")
        }

        !incrementSeconds && !timeMinutes && emptyInputs.push("Time Variant")
        setMissingInputs(emptyInputs)
        return emptyInputs.length === 0;
    }

    //This is kinda hacky, but currently it's to handle a minor bug where we can have no inputs when going to custom
    //jumpstart. So we manually restore the default values
    const toggleCustomJumpstart = () => {
        if(!isCustomJumpstart) {
            setEvalRange([0, 5])
            setMoveRange([10, 100])
        }
        setIsCustomJumpstart((prevState) => !prevState)
    }

    const startGame = () => {
        if(!validateSubmission()) return;

        const gameOffer = {
            baseTime: timeMinutes,
            increment: incrementSeconds,
            variant: selectedVariant,
            clubId,
            selectedColor,
            isCreatorsHandicap
        };

        if (selectedVariant === "jumpstart") {
            gameOffer.lower_eval_limit = evalRange[0];
            gameOffer.upper_eval_limit = evalRange[1];
            gameOffer.lower_move_limit = moveRange[0];
            gameOffer.upper_move_limit = moveRange[1];
        }

        if(friendName) {
            gameOffer.friendName = friendName;
            socket.emit("createFriendChallenge", gameOffer)
        } else {
            socket.emit("createGameOffer", gameOffer);
        }

        closeModal();
    };

    const updateEvalRange = (lowerBound, upperBound, optionId) => {
        if (evalOptionSelected === optionId) {
            setEvalOptionSelected(null)
            setEvalRange([])
        } else {
            setEvalOptionSelected(optionId)
            setEvalRange([lowerBound, upperBound])
        }
    }

    const updateMoveRange = (lowerBound, upperBound, optionId) => {
        if (moveOptionSelected === optionId) {
            setMoveOptionSelected(null)
            setMoveRange([])
        } else {
            setMoveOptionSelected(optionId)
            setMoveRange([lowerBound, upperBound])
        }
    }

    const GameOption = (props) => {
        const isSelected = props.id === optionSelected

        const setVariantAndShowSelected = () => {
            setTimeMinutes(props.timeMinutes)

            props.incrementSeconds ? setIncrementSeconds(props.incrementSeconds) : setIncrementSeconds(0)
            //we rely on the state of the CreateGameModal here, so this component is tightly coupled
            //Also we set anySelected to false, as we are untoggling the selected button

            if (optionSelected === props.id) {
                setOptionSelected(null)
            } else {
                setOptionSelected(props.id)
            }

        }

        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: "#888",
                cursor: "pointer",
                borderRadius: "0.4rem",
                backgroundColor: isSelected ? "#dceeff" : "inherit",
                minHeight: "0"
            }} onClick={setVariantAndShowSelected}>
                <p style={{
                    fontSize: "min(1.5vh, 0.75rem)",
                    fontWeight: "550",
                    marginBottom: "0"
                }}>{props.timeVariant.title}</p>
                <img src={props.timeVariant.imageSrc} alt={"A symbol showing the time variant"}
                     style={{maxHeight: "4rem", minHeight: "1rem"}}/>
                <p style={{
                    marginTop: "-0.2rem",
                    fontWeight: "700",
                    fontSize: "min(1.5vh, 0.75rem)"
                }}>{props.timeMinutes} {props.incrementSeconds ? `+ ${props.incrementSeconds}` : ""}</p>
            </div>
        )
    }

    const JumpstartOption = (props) => {
        const isMoveOption = props.type === "moveOption"

        //This is tightly coupled to the create game modal - but we can move it to props if we wanna move it somewhere else
        const isSelected = isMoveOption ? props.id === moveOptionSelected : props.id === evalOptionSelected;

        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: "#888",
                cursor: "pointer",
                borderRadius: "0.4rem",
                backgroundColor: isSelected ? "#dceeff" : "inherit",
                minHeight: "0"
            }} onClick={() => props.onClick(props.lowerBound, props.upperBound, props.id)}>
                <p style={{fontSize: "min(1.5vh, 0.75rem)", fontWeight: "550", marginBottom: "0"}}>{props.title}</p>
                <img src={props.imageSrc} alt={"A symbol showing the jumpstart variant"}
                     style={{maxHeight: "4rem", minHeight: "1rem"}}/>
                <p style={{
                    marginTop: "-0.1rem",
                    fontWeight: "700",
                    fontSize: "min(1.5vh, 0.75rem)"
                }}>{props.lowerBound + " - " + props.upperBound}</p>
            </div>
        )
    }


    return (
        showCreateModal && (
            <div className="modal-overlay" onClick={closeModal}>
                <div className="create-game-modal" onClick={(e) => e.stopPropagation()}>
                    <button
                        className="close-button"
                        onClick={closeModal}
                        aria-label="Close modal"
                    >
                        &times;
                    </button>

                    <h2 className="modal-title">Create a New Game</h2>

                    {/* Variant selection */}
                    <div className="form-group">
                        <label className="form-label" htmlFor="variantSelect">
                            Variant
                        </label>
                        <select
                            id="variantSelect"
                            className="form-select"
                            value={selectedVariant}
                            onChange={(e) => setSelectedVariant(e.target.value)}
                            style={{color: "#666"}}
                        >
                            <option value="standard">Standard</option>
                            <option value="jumpstart">Jumpstart Chess</option>
                        </select>
                    </div>
                    {isCustomTime ?
                        <>
                            <div className="form-group">
                                <label className="form-label" htmlFor="colorSelect">
                                    Play as:
                                </label>
                                <select
                                    id="colorSelect"
                                    className="form-select"
                                    value={selectedColor}
                                    onChange={(e) => setSelectedColor(e.target.value)}
                                >
                                    <option value="random">Random</option>
                                    <option value="white">White</option>
                                    <option value="black">Black</option>
                                </select>
                            </div>

                            {/* Time slider (Minutes per player) */}
                            <div className="slider-group">
                                <label className="slider-label">
                                    Minutes per player: <span>{timeMinutes}</span>
                                </label>
                                <input
                                    className="slider"
                                    type="range"
                                    min="0.5"
                                    max="60"
                                    step="0.5"
                                    value={timeMinutes}
                                    onChange={(e) => setTimeMinutes(Number(e.target.value))}
                                />
                            </div>

                            {/* Increment slider (seconds) */}
                            <div className="slider-group">
                                <label className="slider-label">
                                    Increment (seconds): <span>{incrementSeconds}</span>
                                </label>
                                <input
                                    className="slider"
                                    type="range"
                                    min="0"
                                    max="30"
                                    step="1"
                                    value={incrementSeconds}
                                    onChange={(e) => setIncrementSeconds(Number(e.target.value))}
                                />
                            </div>
                        </> :
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, 1fr)",
                            minHeight: "0",
                            gridAutoRows: '1 fr'
                        }}>
                            <GameOption id={1} timeVariant={TimeVariants.BULLET} timeMinutes={"1"}/>
                            <GameOption id={2} timeVariant={TimeVariants.BULLET} timeMinutes={"1"}
                                        incrementSeconds={"2"}/>
                            <GameOption id={3} timeVariant={TimeVariants.BULLET} timeMinutes={"2"}
                                        incrementSeconds={"1"}/>
                            <GameOption id={4} timeVariant={TimeVariants.BLITZ} timeMinutes={"3"}
                                        incrementSeconds={"2"}/>
                            <GameOption id={5} timeVariant={TimeVariants.BLITZ} timeMinutes={"5"}/>
                            <GameOption id={6} timeVariant={TimeVariants.BLITZ} timeMinutes={"5"}
                                        incrementSeconds={"5"}/>
                            <GameOption id={7} timeVariant={TimeVariants.RAPID} timeMinutes={"10"}/>
                            <GameOption id={8} timeVariant={TimeVariants.RAPID} timeMinutes={"10"}
                                        incrementSeconds={"5"}/>
                            <GameOption id={9} timeVariant={TimeVariants.RAPID} timeMinutes={"15"}
                                        incrementSeconds={"10"}/>
                            <GameOption id={10} timeVariant={TimeVariants.CLASSIC} timeMinutes={"60"}
                                        incrementSeconds={"15"}/>
                            <GameOption id={11} timeVariant={TimeVariants.CLASSIC} timeMinutes={"90"}
                                        incrementSeconds={"30"}/>
                            <GameOption id={12} timeVariant={TimeVariants.CLASSIC} timeMinutes={"120"}
                                        incrementSeconds={"60"}/>
                        </div>
                    }

                    {selectedVariant === "jumpstart" &&
                        <>
                            {isCustomJumpstart ?
                                <>
                                    <div className="slider-group">
                                        <CustomRange
                                            title="Eval Range"
                                            min={0}
                                            max={5}
                                            step={0.2}
                                            onChange={setEvalRange}
                                        />
                                    </div>
                                    <div className="slider-group">
                                        <CustomRange
                                            title="Move Range"
                                            min={10}
                                            max={100}
                                            step={1}
                                            onChange={setMoveRange}
                                        />
                                    </div>
                                </>
                                :
                                <>
                                    <p style={{
                                        color: "#666",
                                        fontWeight: 700,
                                        fontSize: "0.75rem",
                                        marginBottom: "-1rem",
                                        marginTop: "-0.5rem"
                                    }}>Game Stage</p>
                                    <div style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(3, 1fr)",
                                        minHeight: "0",
                                        gridAutoRows: '1 fr'
                                    }}>
                                        <JumpstartOption id={1} imageSrc={"/sunrise.png"} title="Early game"
                                                         lowerBound={10}
                                                         upperBound={20} type="moveOption" onClick={updateMoveRange}/>
                                        <JumpstartOption id={2} imageSrc={"/midday.png"} title="Mid game"
                                                         lowerBound={20}
                                                         upperBound={40} type="moveOption" onClick={updateMoveRange}/>
                                        <JumpstartOption id={3} imageSrc={"/nighttime.png"} title="Late game"
                                                         lowerBound={40}
                                                         upperBound={100} type="moveOption" onClick={updateMoveRange}/>
                                    </div>
                                    <p style={{
                                        color: "#666",
                                        fontWeight: 700,
                                        fontSize: "0.75rem",
                                        marginBottom: "-1rem",
                                        marginTop: "-0.5rem"
                                    }}>Handicap</p>
                                    <div style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(3, 1fr)",
                                        minHeight: "0",
                                        gridAutoRows: '1 fr'
                                    }}>
                                        <JumpstartOption id={1} imageSrc={"/hiking.png"} title="Almost Even"
                                                         lowerBound={0}
                                                         upperBound={1} type="evalOption" onClick={updateEvalRange}/>
                                        <JumpstartOption id={2} imageSrc={"/stairs.png"} title="Uphill battle"
                                                         lowerBound={1}
                                                         upperBound={3} type="evalOption" onClick={updateEvalRange}/>
                                        <JumpstartOption id={3} imageSrc={"/mountain.png"} title="Free Climbing"
                                                         lowerBound={3}
                                                         upperBound={5} type="evalOption" onClick={updateEvalRange}/>
                                    </div>
                                </>
                            }
                            <button className="minimalist-button"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: "-1rem",
                                        marginBottom: "-0.5rem",
                                        padding: "0",
                                        fontSize: "min(1.5vh, 0.75rem)"
                                    }}
                                    onClick={() => setIsCreatorsHandicap((prev) => !prev)}><span
                                style={{marginRight: "0.5rem"}}>I want the handicap</span> {isCreatorsHandicap ?
                                <img src={"/checked_box.png"} alt={"Checked Box"}/> :
                                <img src={"/empty_box.png"} alt={"Empty Box"}/>}
                            </button>
                        </>
                    }

                    <div className="button-row" style={{justifyContent: "space-between", fontSize: "min(1.5vh, 0.5rem)"}}>
                        <button className="minimalist-button" style={{padding: "0", fontSize: "inherit"}}
                                onClick={() => setIsCustomTime(!isCustomTime)}>{isCustomTime ? "Show Standard Times" : "Select Custom Time"}</button>
                        {selectedVariant === "jumpstart" && <button className="minimalist-button" style={{padding: "0", fontSize: "inherit"}}
                                                                    onClick={toggleCustomJumpstart}>
                            {isCustomJumpstart ? "Show Standard Jumpstart Options" : "Configure Custom Jumpstart"}</button>}
                        <div style={{display: "flex", flexDirection: "row"}}>
                            <button onClick={startGame} style={{marginRight: "0.4rem", fontSize: "inherit"}}>
                                Start Game
                            </button>
                            <button className="secondary-button" onClick={closeModal} style={{fontSize: "inherit"}}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    {missingInputs.length > 0 && <div className="info-message error"
                         style={{width: "fit-content", fontSize: "0.8rem", marginBottom: "-1rem", marginTop: "-0.5rem", borderRadius: "0.3rem"}}>
                        {`You are missing the following input fields: ${missingInputs.join(", ")}`}
                    </div>}
                </div>
            </div>
        )
    )
};

export default CreateGameModal;





